import { ListBox } from 'primereact/listbox';

export default ListBox;
